module.exports = __webpack_public_path__ + "media/videos/new_welcome_video-3ec2e55f10acc665e82d6689aa2acfe5.flv";